/**
 * Relax Master — WebwinkelKeur score: één vaste, site-brede waarde.
 * Centrale bron = snippets/rm-wwk-score.liquid + de collectie-secties.
 * Zet elk scoreveld (homepage, collecties, PDP, reviews) op hetzelfde cijfer,
 * zodat de hele site gelijk loopt. Pas SCORE hieronder aan om te wijzigen.
 */
(function () {
  'use strict';

  var SCORE = '9,2';

  function apply() {
    document.querySelectorAll('[data-rm-wwk-score], [data-rm-rev-score]').forEach(function (el) {
      el.textContent = SCORE;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply);
  } else {
    apply();
  }
  window.addEventListener('load', apply);
})();
